// Class: openfl.utils.IExternalizable

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var IExternalizable = function() {}

// Meta

IExternalizable.__name__ = "openfl.utils.IExternalizable";
IExternalizable.__isInterface__ = true;
IExternalizable.prototype = {
	
};
IExternalizable.prototype.__class__ = IExternalizable.prototype.constructor = $hxClasses["openfl.utils.IExternalizable"] = IExternalizable;

// Init



// Statics




// Export

exports.default = IExternalizable;